// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tasks_container__r-dkc {
  padding: 20px;
}

.Tasks_controls__sT-Rm {
   display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.Tasks_kanbanView__tBxj1 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.Tasks_kanbanColumn__LpT1B {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
}

.Tasks_kanbanColumn__LpT1B h3 {
  margin-top: 0;
  text-align: center;
}

.Tasks_kanbanCards__PG-aA {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.Tasks_kanbanCard__MkcvJ {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
}

.Tasks_kanbanCardContent__p3Gkp {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Tasks_kanbanCardMeta__CTvzz {
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  color: #666;
}
.Tasks_kanbanColumnHeader__te2Mm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
}

.Tasks_countBadge__t6Hle {
  background: #6c757d;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
}

.Tasks_kanbanActions__aBrDC {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 10px;
}

.Tasks_kanbanActions__aBrDC button {
  width: 100%;
  padding: 5px;
  font-size: 0.8em;
}`, "",{"version":3,"sources":["webpack://./src/components/Tasks/Tasks.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;GACG,aAAa;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".container {\n  padding: 20px;\n}\n\n.controls {\n   display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.kanbanView {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.kanbanColumn {\n  background: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n}\n\n.kanbanColumn h3 {\n  margin-top: 0;\n  text-align: center;\n}\n\n.kanbanCards {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.kanbanCard {\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: white;\n}\n\n.kanbanCardContent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kanbanCardMeta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8em;\n  color: #666;\n}\n.kanbanColumnHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.countBadge {\n  background: #6c757d;\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8em;\n}\n\n.kanbanActions {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-top: 10px;\n}\n\n.kanbanActions button {\n  width: 100%;\n  padding: 5px;\n  font-size: 0.8em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Tasks_container__r-dkc`,
	"controls": `Tasks_controls__sT-Rm`,
	"kanbanView": `Tasks_kanbanView__tBxj1`,
	"kanbanColumn": `Tasks_kanbanColumn__LpT1B`,
	"kanbanCards": `Tasks_kanbanCards__PG-aA`,
	"kanbanCard": `Tasks_kanbanCard__MkcvJ`,
	"kanbanCardContent": `Tasks_kanbanCardContent__p3Gkp`,
	"kanbanCardMeta": `Tasks_kanbanCardMeta__CTvzz`,
	"kanbanColumnHeader": `Tasks_kanbanColumnHeader__te2Mm`,
	"countBadge": `Tasks_countBadge__t6Hle`,
	"kanbanActions": `Tasks_kanbanActions__aBrDC`
};
export default ___CSS_LOADER_EXPORT___;
